module.exports = __webpack_public_path__ + "54eac6c6567c093f6c69e106594ca0d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-cowboy-s.png
// module id = 1879
// module chunks = 0